// extracted by mini-css-extract-plugin
export var additionalLink = "menu-item-module--additionalLink--b7e61";
export var back = "menu-item-module--back--00e7d";
export var hasChildren = "menu-item-module--hasChildren--12a50";
export var header = "menu-item-module--header--cf96c";
export var hide = "menu-item-module--hide--45e54";
export var image = "menu-item-module--image--5c9fe";
export var main = "menu-item-module--main--c9b28";
export var menuTitle = "menu-item-module--menuTitle--0c783";
export var open = "menu-item-module--open--66dae";
export var priMenu = "menu-item-module--priMenu--f8888";
export var root = "menu-item-module--root--0ad35";
export var secMenu = "menu-item-module--secMenu--be83e";
export var subMenuOpen = "menu-item-module--subMenuOpen--61a32";
export var submenu = "menu-item-module--submenu--efdb2";